<template>
  <v-dialog
    v-model="internalValue"
    :max-width="maxWidth"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-card class="position-relative">
      <v-card-title class="d-flex flex-nowrap justify-space-between align-start pt-12">
        <span class="text-h5 text-center flex-grow-1">{{ title }}</span>
      </v-card-title>

      <v-btn
        class="base-dialog__close-btn"
        icon
        @click="closeDialog"
      >
        <v-icon>{{ icons.mdiClose }}</v-icon>
      </v-btn>

      <v-card-text class="pt-0 px-12 pb-7">
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, defineComponent } from '@vue/composition-api';
import { mdiClose } from '@mdi/js';

export default defineComponent({
  name: 'BaseDialog',
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    maxWidth: {
      type: [String, Number],
      default: '650',
    },
  },
  setup(props, { emit }) {
    const internalValue = computed({
      get: () => props.value,
      set: (newValue) => {
        emit('input', newValue);
      },
    });

    const closeDialog = () => {
      internalValue.value = false;
      emit('close');
    };

    return {
      internalValue,
      closeDialog,
      icons: {
        mdiClose,
      },
    };
  },
});
</script>

<style scoped>
.base-dialog__close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
}
</style>

